'use client';

/**
 * Draws the portrait of a random tiger the server gave this account
 * (backend lib/tigerAuto.ts: at sign-up, or for an account that never made
 * one) and saves it as the profile picture, exactly as Edit Avatar's "Apply to
 * profile" does. Asks once per browser session; renders nothing.
 */

import { useEffect } from 'react';
import { announceAvatar, fetchPendingTiger, loadTiger, portraitPng, saveMyTiger } from '@/lib/tiger';

const ASKED = 'tigerPendingAsked';

export default function TigerPortraitFinisher() {
  useEffect(() => {
    try { if (sessionStorage.getItem(ASKED)) return; sessionStorage.setItem(ASKED, '1'); } catch { /* storage blocked: ask anyway */ }
    // Not cancelled on unmount: the save must finish even if the page changes (and Strict Mode mounts twice).
    (async () => {
      const p = await fetchPendingTiger();
      if (!p.pending || !p.config) return;
      const rt = await loadTiger();
      const config = rt.normalize(p.config).config;
      const r = await saveMyTiger(config, await portraitPng(rt, config), true);
      announceAvatar(r.avatarKey);
    })().catch(() => { try { sessionStorage.removeItem(ASKED); } catch { /* ignore */ } });
  }, []);
  return null;
}
